export default __webpack_public_path__ + "static/media/005-bananas.22a26fe5.svg";